import { render, staticRenderFns } from "./EditLogo.vue?vue&type=template&id=cf8ddcf0"
import script from "./EditLogo.vue?vue&type=script&lang=js"
export * from "./EditLogo.vue?vue&type=script&lang=js"
import style0 from "./EditLogo.vue?vue&type=style&index=0&id=cf8ddcf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports